<template>
  <div class="dropdownDoc">
      <div class="progressStat">
        <h1 class="subhead">PROGRESS STATUS</h1>
      </div>
        <label-status class="dropdownDoc__item"/>
        <label-status class="dropdownDoc__item" :progress="validating"/>
        <label-status class="dropdownDoc__item" :progress="verifying"/>
        <label-status class="dropdownDoc__item" :progress="designing"/>
        <label-status class="dropdownDoc__item" :progress="designapproval"/>
        <label-status class="dropdownDoc__item" :progress="printing"/>
        <label-status class="dropdownDoc__item" :progress="printapproval"/>
        <label-status class="dropdownDoc__item" :progress="wrapping"/>
        <label-status class="dropdownDoc__item" :progress="done"/>
      <div class="semanticStat">
        <h1 class="subhead">PAYMENT STATUS</h1>
      </div>
        <label-status class="dropdownDoc__item" :progress="pending"/>
        <label-status class="dropdownDoc__item" :progress="afterpay"/>
        <label-status class="dropdownDoc__item" :progress="paid"/>
        <label-status class="dropdownDoc__item" :progress="downpayment"/>
        <label-status class="dropdownDoc__item" :progress="partially"/>
      <div class="semanticStat">
        <h1 class="subhead">ADDITIONAL STATUS</h1>
      </div>
      <label-status class="dropdownDoc__item" :progress="upcoming"/>
      <!-- <label-status class="dropdownDoc__item" :progress="verifying"/> -->
      <label-status class="dropdownDoc__item" :progress="draft"/>
      <label-status class="dropdownDoc__item" :progress="active"/>
      <label-status class="dropdownDoc__item" :progress="expired"/>
      <label-status class="dropdownDoc__item" :progress="canceled"/>
      <label-status class="dropdownDoc__item" :progress="dormant"/>
      <!-- value :color props must be css code color -->
      <div class="semanticStat">
        <h1 class="subhead">CUSTOM COLOR LABEL STATUS</h1>
      </div>
      <adx-label-custom class="dropdownDoc__item" :color="'#47d1af'" :label="'CUSTOM LABEL'"/>
      <div class="semanticStat">
        <h1 class="subhead">PREMIUM LABEL STATUS</h1>
        <adx-label-custom class="dropdownDoc__item" :color="'#47d1af'" :label="'SPBU'"/>
        <adx-label-custom class="dropdownDoc__item" :color="'#ceb521'" :type="'premium'" :label="'Premium'"/>
      </div>
  </div>
</template>

<script>
import DropdownStatus from '@/components/Dropdown/StatusDropdown'
import LabelStatus from '@/components/StatusLabel'
import LabelStatusCustom from '@/components/StatusLabelCustom'



export default {
  name: 'adx-custom-label',
  components: {
    DropdownStatus,
    LabelStatus,
     'adx-label-custom': LabelStatusCustom

  },
  data() {
    return {
      validating: {
        'label': 'VALIDATING',
        'value': 'validating'
      },
      verifying: {
        'label': 'VERIFYING',
        'value': 'verifying'
      },
      designing:  {
        'label': 'DESIGNING',
        'value': 'designing'
      },
      designapproval: {
        'label': 'DESIGN APPROVAL',
        'value': 'designapproval'
      },
      printing: {
        'label': 'PRINTING',
        'value': 'printing'
      },
      printapproval: {
        'label': 'PRINT APPROVAL',
        'value': 'printapproval'
      },
      wrapping: {
        'label': 'WRAPPING',
        'value': 'wrapping'
      },
      done: {
        'label': 'DONE',
        'value': 'done'
      },
      pending: {
        'label': 'PENDING',
        'value': 'pending'
      },
      active: {
        'label': 'ACTIVE',
        'value': 'active'
      },
       canceled: {
        'label': 'CANCELED',
        'value': 'canceled'
      },
       expired: {
        'label': 'EXPIRED',
        'value': 'expired'
      },
       afterpay: {
        'label': 'AFTERPAY',
        'value': 'afterpay'
      },
      paid: {
        'label': 'PAID',
        'value': 'paid'
      },
      upcoming: {
        'label': 'UPCOMING',
        'value': 'upcoming '
      },
      partially: {
        'label': 'PARTIALLY',
        'value': 'partially'
      },
       downpayment: {
        'label': 'DOWNPAYMENT',
        'value': 'downpayment '
      },
      waitingapproval: {
        'label': 'WAITING APPROVAL',
        'value': 'waitingapproval'
      },
      dormant: {
        'label': 'DORMANT',
        'value': 'dormant'
      },
      draft: {
        'label': 'DRAFT',
        'value': 'draft'
      },
      selectedSearchValue: ''
    }
  },
  methods: {
    selected(item){
      
    },
    selectedSearch(item){
      this.selectedSearchValue = item.id.toString()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>